import { render, staticRenderFns } from "./CameraMedia.vue?vue&type=template&id=52ff1928&"
import script from "./CameraMedia.vue?vue&type=script&lang=js&"
export * from "./CameraMedia.vue?vue&type=script&lang=js&"
import style0 from "./CameraMedia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports